import React, { useEffect, useRef } from 'react'
import Hls from 'hls.js'
import mux from 'mux-embed'

interface VideoPlayerProps {
  src: string
  poster?: string
  uid: string
  videoTitle: string
  sessionSlug: string
  streamType: string
}

const VideoPlayer = ({ src, poster, uid, videoTitle, sessionSlug, streamType }: VideoPlayerProps) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const initTime = Date.now()
    let hls
    const video = videoRef.current
    if (!video) {
      return
    }

    video.controls = true

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      // This will run in safari, where HLS is supported natively
      video.src = src
    } else if (Hls.isSupported()) {
      // This will run in all other modern browsers
      hls = new Hls()
      hls.loadSource(src)
      hls.attachMedia(video)

      if (typeof mux !== 'undefined') {
        mux.monitor(video, {
          debug: false,
          hlsjs: hls,
          Hls: Hls,
          data: {
            env_key: '8kglvq31ijo335ve96edqn5nm', // required
            // Metadata fields
            player_name: 'Mux Player', // any arbitrary string you want to use to identify this player
            player_init_time: initTime, // ex: 1451606400000
            viewer_user_id: uid,
            video_title: videoTitle,
            video_id: sessionSlug,
            video_stream_type: streamType,
            // ...
          },
        })
      }
    } else {
      console.error(
        'This is an old browser that does not support MSE https://developer.mozilla.org/en-US/docs/Web/API/Media_Source_Extensions_API',
      )
    }

    return () => {
      if (hls) {
        hls.destroy()
      }
    }
  }, [src, videoRef])

  return <video controls className="w-full" ref={videoRef} poster={poster} src={src} />
}

export default VideoPlayer
